import React from 'react'
import Modal from 'react-bootstrap/lib/Modal.js'
class ModalImagenes extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            selectedCategory: "inicio",
            currentIndex: 0,
        }
    }

    componentDidMount() {
        this.props.imagenes(this.props.idInventario)
    }

    render() {
        const { currentIndex, selectedCategory } = this.state;
        console.log(this.props)
        return (
            <Modal show={this.props.showModal} onHide={this.props.cancelModal} bsSize="large">
                <Modal.Header closeButton>
                    <Modal.Title>Imágenes de Inventario</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {!Array.isArray(this.props.indicators) ? (
                        <div style={{ width: '100%', height: '70vh', margin: 'auto', textAlign: 'center' }}>
                            <div style={{ gap: '10px', display: 'flex', justifyContent: 'center' }}>
                                <button
                                    className={`btn btn-${selectedCategory === "inicio" ? "primary" : "secondary"}`}
                                    onClick={() =>
                                        this.setState({ selectedCategory: "inicio", currentIndex: 0 })
                                    }
                                >
                                    Fotos Inicio
                                </button>
                                <button
                                    className={`btn btn-${selectedCategory === "cierre" ? "primary" : "secondary"}`}
                                    onClick={() =>
                                        this.setState({ selectedCategory: "cierre", currentIndex: 0 })
                                    }
                                >
                                    Fotos Cierre
                                </button>
                            </div>
                            <div
                                className="align-items-center"
                                style={{ height: '100%', display: 'flex', justifyContent: 'center'}}
                            >
                                <button
                                    className="btn btn-info"
                                    style={{ height: '40px', margin: 'auto' }}
                                    onClick={() =>
                                        this.setState({
                                            currentIndex:
                                                (currentIndex - 1),
                                        })
                                    }
                                    disabled={currentIndex == 0}
                                >
                                    <span className='glyphicon glyphicon-chevron-left' style={{ verticalAlign: 'center', alignContent: 'center' }}></span> {/* Flecha izquierda */}
                                </button>
                                <div
                                    style={{
                                        width: '60%',
                                        height: '100%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <img
                                        src={selectedCategory === "cierre" ? this.props.indicators.foto_cierre[currentIndex] : this.props.indicators.foto_inicio[currentIndex]}
                                        alt={`Foto ${currentIndex + 1}`}
                                        style={{
                                            maxWidth: '100%',
                                            maxHeight: '100%',
                                            borderRadius: '8px',
                                            border: '1px solid #ddd',
                                        }}
                                    />
                                </div>
                                <button
                                    className="btn btn-info"
                                    style={{ height: '40px', margin: 'auto' }}
                                    onClick={() =>
                                        this.setState({
                                            currentIndex: (currentIndex + 1)
                                        })
                                    }
                                    disabled={(currentIndex + 1) >= (selectedCategory === "cierre" ? this.props.indicators.foto_cierre.length  : this.props.indicators.foto_inicio.length)}
                                >
                                    <span className='glyphicon glyphicon-chevron-right' style={{ verticalAlign: 'center', alignContent: 'center' }}></span>
                                </button>
                            </div>
                        </div>
                    ) : (
                        <p style={{ textAlign: 'center' }}>No hay imágenes disponibles.</p>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <a
                        className="btn btn-primary"
                        href={`/inventario/archivo-final/${this.props.id_file[0].indicator.id_file}/descargar-imagenes-cliente`}
                        target="_blank"
                    >
                        Descargar Imágenes
                    </a>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default ModalImagenes


// WEBPACK FOOTER //
// ./frontEnd/home/components/ModalImagenes.jsx